"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var angular_1 = __importDefault(require("angular"));
var vue_1 = __importDefault(require("vue"));
require("ngVue");
var InstructorViewCourse_vue_1 = __importDefault(require("./InstructorViewCourse.vue"));
var instructor_view_course_html_1 = __importDefault(require("./instructor-view-course.html"));
var instructor_view_course_controller_1 = __importDefault(require("./instructor-view-course.controller"));
function config($stateProvider, $urlRouterProvider, USER_ROLES) {
    $stateProvider.state("drivecoach.instructor.dashboard.course.view", {
        url: "/view",
        template: instructor_view_course_html_1.default,
        controller: instructor_view_course_controller_1.default,
        controllerAs: "vm",
        resolve: {
            course: getCourse,
        },
        data: {
            authorizedRoles: [
                USER_ROLES.admin,
                USER_ROLES.administrator,
                USER_ROLES.owner,
                USER_ROLES.instructor,
            ],
        },
    });
}
config.$inject = ["$stateProvider", "$urlRouterProvider", "USER_ROLES"];
function getCourse($stateParams, CoursesModel) {
    return CoursesModel.show($stateParams.courseId).then(function (response) {
        return response.course;
    });
}
getCourse.$inject = ["$stateParams", "CoursesModel"];
exports.default = angular_1.default
    .module("instructor.dashboard.course.view", [])
    .config(config)
    .controller("InstructorViewCourseController", instructor_view_course_controller_1.default)
    .directive("dcInstructorViewCourse", [
    "createVueComponent",
    function (createVueComponent) {
        return createVueComponent(vue_1.default.component("DcInstructorViewCourse", InstructorViewCourse_vue_1.default));
    },
]);
